import { EnterpriseQuoteService } from './enterprise-quote-service';
import { queryClient } from '../query-client';
export const enterpriseQuoteService = new EnterpriseQuoteService({
    resource: 'enterprise-quote',
    parentResources: [],
    middleware: [],
    queryClient,
});
